import { render, staticRenderFns } from "./psa-main-page.vue?vue&type=template&id=45872386&scoped=true&"
import script from "./psa-main-page.vue?vue&type=script&lang=tsx&"
export * from "./psa-main-page.vue?vue&type=script&lang=tsx&"
import style0 from "./psa-main-page.vue?vue&type=style&index=0&id=45872386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45872386",
  null
  
)

export default component.exports